<template>
  <Loader v-if="isLoading"  visible/>
  <div class="tutorials-list-container">
    <div class="d-flex align-items-center justify-content-between">
      <h2 class="tutorials-list-title">📝 Tutorials</h2>

      <button v-if="isModerator" class="tutorials-list-item-button new-tutorial-button" @click="openCreateModal" >
        ➕
      </button>
    </div>

      <div class="tutorials-list-search">
        <div class="input-group">
          <input type="text"
                 class="search-input"
                 placeholder="🔍  Search by title"
                 v-model="title"
                 @input="searchTitle"
          />
        </div>
      </div>

      <div class="tutorials-list ">
        <div v-for="(tutorial, index) in tutorials" :key="index"
            class="tutorials-list-item col-md-4"
            @click.stop="openTutorialPage(tutorial.id)">

          <div class="d-flex align-items-center">
            <div class="tutorials-list-item-photo" :style="tutorial.photo ? { backgroundImage: `url(${tutorial.photo})` } : {}">
              <button v-if="isModerator" class="tutorials-list-item-button tutorials-list-item-button-edit-desk hide-on-mobile" @click.stop="openEditModal(tutorial)">✏️</button>
            </div>
            <span class="tutorials-list-item-title">{{ tutorial.title }}</span>
            <button v-if="isModerator" class="tutorials-list-item-button hide-on-desktop" @click.stop="openEditModal(tutorial)">✏️</button>
          </div>
        </div>
      </div>


    <ModalComponent
        v-if="isEditModalVisible"
        :isVisible="isEditModalVisible"
        title="Edit Tutorial"
        @close="closeEditModal"
    >
      <div>
        <div class="form-group">
          <label for="title">Title</label>
          <input type="text" class="form-control" v-model="currentTutorial.title" />
        </div>
        <div class="form-group">
          <label for="newDescription">Description</label>
          <textarea
              class="form-control form-control-description"
              v-model="newTutorial.description"
              rows="1"
              @input="adjustHeight($event)">
          </textarea>
        </div>
        <div class="form-group">
          <label for="status">Status</label>
          <select class="form-control" v-model="currentTutorial.published">
            <option :value="true">Published</option>
            <option :value="false">Pending</option>
          </select>
        </div>
        <div class="form-group">
          <label for="photo">Photo</label>
          <input type="file" class="form-control" @change="handlePhotoUpload" />
          <div v-if="previewPhoto" class="preview-photo" :style="{ backgroundImage: `url(${previewPhoto})` }"></div>
        </div>
      </div>
      <template #footer>
        <button class="btn btn-success" @click="saveChanges">✅ Save changes</button>
        <button class="btn btn-danger" @click="deleteTutorial(currentTutorial?.id)">🗑 Delete</button>
      </template>
    </ModalComponent>

    <ModalComponent
        v-if="isCreateModalVisible"
        :isVisible="isCreateModalVisible"
        title="Create New Tutorial"
        @close="closeCreateModal"
    >
      <div>
        <div class="form-group">
          <label for="newTitle">Title</label>
          <input type="text" class="form-control" v-model="newTutorial.title" />
        </div>
        <div class="form-group">
          <label for="newDescription">Description</label>
          <textarea
              class="form-control form-control-description"
              v-model="newTutorial.description"
              rows="1"
              @input="adjustHeight($event)">
          </textarea>
        </div>
      </div>
      <template #footer>
        <button class="btn btn-success" @click="createTutorial">✅ Create</button>
      </template>
    </ModalComponent>
  </div>
</template>

<script>
import TutorialDataService from "../../../services/TutorialDataService";
import ModalComponent from "../modal/ModalComponent.vue";
import Notification from "../Notification.vue";
import Loader from "../Loader.vue";
import {mapGetters} from "vuex";
import { notificationMixin } from "../../../mixins/notificationMixin"
import { s3Service } from "../../../services/s3Service"

export default {
  name: "TutorialsList",
  components: {Notification, ModalComponent, Loader},
  mixins: [notificationMixin],
  data() {
    return {
      tutorials: [],
      allTutorials: [],
      currentTutorial: null,
      currentIndex: -1,
      title: "",
      newTutorial: { title: '', description: '', published: false },
      isLoading: false,
      isEditModalVisible: false,
      isCreateModalVisible: false,
      photoFile: null,
      previewPhoto: null,
    };
  },
  computed: {
    ...mapGetters('auth', ['isAdmin', 'isModerator']),
  },
  methods: {
    async retrieveTutorials() {
      this.isLoading = true;
      try {
        const response = await TutorialDataService.getAll();
        this.allTutorials = response.data;
        this.tutorials = [...this.allTutorials];
      } catch (e) {
        console.error("Error loading tutorials:", e);
        this.$root.showNotification("Failed to load tutorials", "error");
      } finally {
        this.isLoading = false;
      }
    },
    refreshList() {
      this.retrieveTutorials();
      this.currentTutorial = null;
      this.currentIndex = -1;
    },
    async createTutorial() {
      try {
        await TutorialDataService.create(this.newTutorial);
        this.refreshList();
        this.closeCreateModal();
        this.newTutorial = { title: "", description: "", published: false };
        this.$root.showNotification("The tutorial was created successfully!", "success");
      } catch (e) {
        console.log(e);
        this.$root.showNotification("The tutorial was created with error!", "error");
      }
    },
    openEditModal(tutorial) {
      this.currentTutorial = { ...tutorial };
      this.isEditModalVisible = true;
    },
    closeEditModal() {
      this.isEditModalVisible = false;
    },
    async saveChanges() {
      try {
        await TutorialDataService.update(this.currentTutorial.id, this.currentTutorial);
        this.refreshList();
        this.closeEditModal();
        this.previewPhoto = null;
        this.$root.showNotification("The tutorial was updated successfully!", "success");
      } catch (e) {
        console.log(e);
        this.$root.showNotification("The tutorial was updated with error!", "error");
      }
    },
    async deleteTutorial(tutorialId) {
      if (window.confirm("Are you sure you want to delete this tutorials?")) {
        try {
          await TutorialDataService.delete(tutorialId);
          this.refreshList();
          this.closeEditModal();
          this.previewPhoto = null;
          this.$root.showNotification("The tutorial was deleted successfully!", "success");
        } catch (e) {
          console.log(e);
          this.$root.showNotification("The tutorial was deleted with error!", "error");
        }
      }
    },
    searchTitle() {
      if (!this.title.trim()) {
        this.tutorials = [...this.allTutorials];
        return;
      }

      const searchTerm = this.title.toLowerCase().trim();
      this.tutorials = this.allTutorials.filter(tutorial =>
        tutorial.title.toLowerCase().includes(searchTerm)
      );
    },
    openCreateModal() {
      this.isCreateModalVisible = true;
      this.newTutorial = { title: '', description: '', published: false };
    },
    closeCreateModal() {
      this.isCreateModalVisible = false;
    },
    openTutorialPage(id) {
        this.$router.push(`/tutorials/${id}`);
    },
    adjustHeight(event) {
      const element = event.target;
      element.style.height = 'auto';
      element.style.height = `${element.scrollHeight}px`;
    },
    async handlePhotoUpload(event) {
      try {
        const file = event.target.files[0];
        if (!file) return;

        const url = await s3Service.uploadFile(file, 'tutorials/photos');
        this.currentTutorial.photo = url;

        const reader = new FileReader();
        reader.onload = (e) => {
          this.previewPhoto = e.target.result;
        };
        reader.readAsDataURL(file);

      } catch (error) {
        console.error('Error uploading photo:', error);
        this.showNotification("Failed to upload photo", "error");
      }
    },
  },
  watch: {
    title: {
      handler(newValue) {
        this.searchTitle();
      },
      debounce: 300
    }
  },
  mounted() {
    this.retrieveTutorials();
  }
};
</script>

<style scoped>

.tutorials-list-container {
  margin-left: 10px;
  margin-right: 10px;
}

.tutorials-list-item-button-edit-desk {
  display: none;
}

.tutorials-list-item:hover .tutorials-list-item-button {
  display: flex;
}

.tutorials-list {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  padding: 0;
  text-decoration: none;
  gap: 10px 15px;
  margin-top: 10px;
}

.tutorials-list-title {
  margin: 0;
}

.tutorials-list-item {
  background-color: var(--my-light);
  cursor: pointer;
  border-radius: 12px;
  text-decoration: none;
  padding-right: 10px;

  flex: 1 1 calc(33.333% - 10px);
  max-width: calc(33.333% - 10px);
}

.tutorials-list-item-photo {
  height: 70px;
  width: 70px;
  min-width: 70px;
  background-color: var(--my-links);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  border-radius: 10px 0 0 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.tutorials-list-item-button {
  border: none;
  font-size: 16px;
  background-color: var(--my-light);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  width: 35px;
  height: 35px;
  cursor: pointer;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
}

.tutorials-list-item-button:hover {
  background-color: var(--my-accent);
  transition: all 0.5s ease;
}


.tutorials-list-item-title {
  color: var(--my-dark);
  margin-left: 7px;
  font-size: 0.9em;
  font-weight: bold;
}

.tutorials-list-item:hover {
  background-color: var(--my-white);
  transition: 0.3s ease-in-out;
}

.form-control-description {
  height: 70px;
}

.search-input {
  margin-top: 15px;
  border: none;
  height: 35px;
  font-size: 0.9em;
  width: 100%;
  padding-left: 10px;
  background-color: var(--my-light);
  padding-right: 10px;
  outline: none;
  border-radius: 10px;
}

.form-group {
  margin-top: 10px;
}

.new-tutorial-button {
  display: flex;
  right: 0 !important;
  position: relative !important;
  margin: 0;
}

.new-tutorial-button:hover {
  right: 0 !important;
  position: relative !important;
  margin: 0;
  background-color: var(--my-links) !important;
}

.preview-photo {
  width: 100px;
  height: 100px;
  background-size: cover;
  background-position: center;
  margin-top: 10px;
  border: 1px solid var(--my-border);
  border-radius: 5px;
}

.new-tutorial-button {
  background-color: var(--my-light) !important;
  font-size: 12px;
  font-weight: bold;
  right: 0 !important;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}





@media (max-width: 1006px) {
  .tutorials-list-item {
    flex: 1 1 calc(50% - 5px);
    max-width: calc(50% - 5px);
  }

  .tutorials-list {
    gap: 10px;
  }
}

@media (max-width: 767px) {

  .tutorials-list {
    flex-direction: row;
  }

  .tutorials-list-search {
    padding: 0;
  }

  .tutorials-list-item {
    width: 100%;
    max-width: 100%;
    flex: 100%;
  }

  .tutorials-list-item-title {
    color: var(--my-dark);
    margin-right: 50px;
    font-size: 0.8em;
    font-weight: bold;
  }

  .new-tutorial-button {
    position: relative !important;
  }



  .tutorials-list-item-button {
    background-color: var(--my-border);
    position: absolute;
    display: flex;
    right: 25px;
  }
}

</style>
